// extracted by mini-css-extract-plugin
export var container = "styles-module--container--5764d";
export var wide = "styles-module--wide--9a8e2";